
  import { defineComponent } from 'vue';
  import './image.scss';

  /**
   * Image component
   * 
   * @example
   * <code>import TpxImage from '@manifesto-tech/tpximpact-design-system/components/atoms/media/image.vue'</code>
   */
  export default defineComponent({
    name: 'TpxImage',
    
    props: {
      /**
       * The alternative text for when the image is not available.
       * For accessiblility reasons you should be as descriptive as possible to improve users who rely on a screen reader to give detail about the image.
       */
      altText: {
        type: String,
        required: true,
      },
      
      /**
       * The height of the image (px)
       */
      height: {
        type: Number,
        required: true,
        validator: (value: number) => {
          return value > 0; 
        },
      },

      /**
       * The source of the image
       */
      src: {
        type: String,
      },

      /**
       * The width of the image (px)
       */
      width: {
        type: Number,
        required: true,
        validator: (value: number) => {
          return value > 0; 
        },
      },
    },

    data() {
      return {
        imageSrc: this.src ?? require('../../../static/images/placeholder.png')
      }
    },
  });
